<template>
  <form id="inicisForm" v-if="inicisRequestParameter">
    <input type="hidden" :value="inicisRequestParameter.version" name="version" />
    <input type="hidden" :value="inicisRequestParameter.gopaymethod" name="gopaymethod" />
    <input type="hidden" :value="inicisRequestParameter.mid" name="mid" />
    <input type="hidden" :value="inicisRequestParameter.oid" name="oid" />
    <input type="hidden" :value="inicisRequestParameter.price" name="price" />
    <input type="hidden" :value="inicisRequestParameter.timestamp" name="timestamp" />
    <input type="hidden" :value="inicisRequestParameter.useChkfake" name="use_chkfake" />
    <input type="hidden" :value="inicisRequestParameter.signature" name="signature" />
    <input type="hidden" :value="inicisRequestParameter.verification" name="verification" />
    <input type="hidden" :value="inicisRequestParameter.mKey" name="mKey" />
    <input type="hidden" :value="inicisRequestParameter.currency" name="currency" />
    <input type="hidden" :value="inicisRequestParameter.goodname" name="goodname" />
    <input type="hidden" :value="inicisRequestParameter.buyername" name="buyername" />
    <input type="hidden" :value="inicisRequestParameter.buyertel" name="buyertel" />
    <input type="hidden" :value="inicisRequestParameter.buyeremail" name="buyeremail" />
    <input type="hidden" :value="inicisRequestParameter.returnUrl" name="returnUrl" />
    <input type="hidden" :value="inicisRequestParameter.closeUrl" name="closeUrl" />
    <input type="hidden" :value="inicisRequestParameter.acceptmethod" name="acceptmethod" />
    <input type="hidden" :value="inicisRequestParameter.iniCardCode" name="ini_cardcode" />
    <input type="hidden" :value="inicisRequestParameter.ansimQuota" name="ansim_quota" />
    <input type="hidden" :value="inicisRequestParameter.quotabase" name="quotabase" />
    <input type="hidden" :value="inicisRequestParameter.merchantData" name="merchantData" />

    <input type="hidden" :value="inicisRequestParameter.nointerest" name="nointerest" />
    <input type="hidden" :value="inicisRequestParameter.tax" name="tax" />
    <input type="hidden" :value="inicisRequestParameter.taxfree" name="taxfree" />
    <input type="hidden" :value="inicisRequestParameter.charset" name="charset" />
    <input type="hidden" :value="inicisRequestParameter.payViewType" name="payViewType" />
    <input type="hidden" :value="inicisRequestParameter.languageView" name="languageView" />
    <input type="hidden" :value="inicisRequestParameter.logoUrl" name="logoUrl" />
    <input type="hidden" :value="inicisRequestParameter.logo2Nd" name="logo2Nd" />
    <input type="hidden" :value="inicisRequestParameter.popupUrl" name="popupUrl" />
    <input type="hidden" :value="inicisRequestParameter.parentemail" name="parentemail" />
    <input type="hidden" :value="inicisRequestParameter.iniSsgpayMdn" name="iniSsgpayMdn" />
    <input type="hidden" :value="inicisRequestParameter.offerPeriod" name="offerPeriod" />
  </form>
</template>

<script setup lang="ts">

import type { PaymentPrepareResDto, InicisRequest } from "~/types/payment/backend-dto-types";
import { ORDER_CODE } from "@/constants/hconMessageConstants"

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const { showAlert } = usePopup()

// 1. 마우스 뒤로가기/앞으로가기 버튼 차단 함수
const preventMouseBackForward = (e: MouseEvent): void => {
  // 3, 4 뒤로가기, 앞으로가기
  if(e.button === 3 || e.button === 4) {
    e.preventDefault()
    e.stopPropagation()
  }
}
const preventKeyEvents = (e: KeyboardEvent): void => {
  // 1. ALt + 왼쪽 화살표
  if(e.altKey && e.key === 'ArrowLeft') {
    e.preventDefault()
  }
  // 2. Backspace
  if(e.key === 'Backspace') {
    const target = e.target as HTMLElement
    if(target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
      e.preventDefault()
    }
  }
  // F5 또는 Ctrl+R
  if(e.key === 'F5' || (e.ctrlKey && e.key === 'r')) {
    // 결제 중 새로고침 금지
    e.preventDefault()
  }
}
// 2. 브라우저 히스토리 고정(뒤로가기 방지)
const lockHistory = () => {
  history.pushState(null, '', window.location.href)
  window.onpopstate = () => {
    history.pushState(null, '', window.location.href)
    // 필요 시 경고 창: 결제 진행 중에는 이동할 수 없습니다.
  }
}
// 3. 결제창 강제 종료 및 청소
const clearInicisDom = () => {
  const targets = ['inicis_layer', 'inicis_modal', 'P_LAYER', 'inicisModalDiv']
  targets.forEach(id => {
    const el = document.getElementById(id)
    if(el && el.parentNode) {
      // el.remove()
      el.parentNode.removeChild(el)
    } 
  })

  document.body.style.overflow = 'auto' // 배경 스크롤 잠금 해제
  window.onpopstate = null // 히스토리 락 해제

  // 모든 이벤트 리스터 제거
  window.removeEventListener('mousedown', preventMouseBackForward)
  window.removeEventListener('keydown', preventKeyEvents)
  window.removeEventListener('beforeunload', lockLeavePage)
}

const lockLeavePage = (e: BeforeUnloadEvent): void => {
  e.preventDefault()
  e.returnValue = "";
}

const props = defineProps<{ inicisRequest?: InicisRequest }>()
const inicisRequestParameter = ref<PaymentPrepareResDto>()
const inicisFetchBuilder = useHconFetchBuilder()
  .post<AjaxResult<PaymentPrepareResDto>>('/api/v1/payments/prepare')
  .body(computed(() => props.inicisRequest))
  .build()
  
const showAlertMsg = () => {
  showAlert({
    title: '알림',
    message: HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9203),
    confirmText: '확인',
    onConfirm: () => {
      window.location.reload()
    }
  })
}

let inicisInterval: any = null

// 결제요청정보 요청
const request = async () => {

  if (!props.inicisRequest) {
    showAlertMsg()
    return
  }

  if (props.inicisRequest.merchantData.paymentDetailList[0].pymtAmt < 1) {
    showAlertMsg()
    return
  }

  if(inicisInterval) clearInterval(inicisInterval)

  inicisFetchBuilder
    .execute()
    .then((res) => {
      if(res.resultCode != '200') {
        return emits('failed', res.resultMessage);
      }

      inicisRequestParameter.value = res.data

      const interval = setInterval(() => {
        let el = document.getElementById('inicisForm')
        if (el) {
          clearInterval(interval);

          // 결제 시작 전 잠금
          lockHistory()
          window.addEventListener('mousedown', preventMouseBackForward)
          window.addEventListener('keydown', preventKeyEvents)
          // window.addEventListener('beforeunload', lockLeavePage) // 이탈 방지

          // 결제 호출
          window.INIStdPay.pay('inicisForm')

          // 종료 감시
          const checkClose = setInterval(() => {

            const inicis = document.getElementById('inicisModalDiv') // inicis_layer, inicisModalDiv

            if (!inicis) {
              clearInterval(checkClose)
              clearInicisDom() // 방어 해제 및 청소
            }
          }, 1000)
        }
      }, 500)
    })
    .catch(err => {
      showAlertMsg()
    })
}

const emits = defineEmits(['failed'])
defineExpose({ request, clearInicisDom });

// #####################################################
// 운영 stdpay.inicis, 테스트 stgstdpay.inicis
// useHead({ script: [{ src: "https://stgstdpay.inicis.com/stdjs/INIStdPay.js", defer: true }] });
useHead({ script: [{ src: "https://stdpay.inicis.com/stdjs/INIStdPay.js", defer: true }] });
// #####################################################

</script>
<style lang="scss" scoped>
</style>
